// Competitor research for the Marketing > Competitors tab.
// Source: the "11 Plus Magic: social media & revenue vs competitors" research page, data checked 30 Oct 2026.
// Numbers are public counts or the brands' own claims as read on that date; "Not found" means it could not be read.
// To update: edit the values below; the Competitors tab renders whatever is here.

export const DATA_CHECKED = "Data checked 30 Oct 2026";

export const VERDICT = "Competitors don't win on social by posting more. They win by being where parents already talk (Facebook groups, forums, YouTube search) and by giving them a free or cheap first step: a diagnostic, a webinar, a £19 mock or a mock day. Then they earn more from tutors, schools and events. 11 Plus Magic has small audiences on every platform, posts lessons aimed at children rather than parents, and earns mainly from a subscription that starts at £29.99 a month, plus school paper packs that are hard to find.";

export const SUMMARY_CARDS = [
  {
    "key": "leader",
    "label": "Market leader",
    "name": "Atom Learning",
    "detail": "“350,000 families and 2,000+ schools” (own claim). Facebook 8.2K; YouTube 4.36K subs, 1.35M views; TikTok 4,265",
    "tone": "purple"
  },
  {
    "key": "closest",
    "label": "Closest product match",
    "name": "Exam Happy",
    "detail": "216 App Store ratings (4.48), #1 for “11 plus”. £179.99 a year vs our £169.99",
    "tone": "blue"
  },
  {
    "key": "games",
    "label": "Closest on games",
    "name": "Pip",
    "detail": "Free core app; 13 iOS ratings (4.15), 500+ Play installs. Pro £7.99/mo",
    "tone": "green"
  },
  {
    "key": "social",
    "label": "Biggest social reach",
    "name": "CGP",
    "detail": "TikTok 38.4K, Instagram 21K, Facebook 9.7K (covers all ages)",
    "tone": "orange"
  },
  {
    "key": "community",
    "label": "Biggest parent community",
    "name": "Eleven Plus Exams",
    "detail": "Forum: 41,391 members, 797,420 posts",
    "tone": "teal"
  },
  {
    "key": "us",
    "label": "11 Plus Magic today",
    "name": "Small on every channel",
    "detail": "Facebook 71; YouTube 17 subs; TikTok 7; 1 App Store rating; 10+ Play installs",
    "tone": "red"
  }
];

export const PRODUCT_SUMMARY = "What 11 Plus Magic actually includes, checked on its site, App Store and Google Play on 30 Oct 2026: timed mocks for GL, CEM and CSSE plus named-school mocks (London 11+ Consortium, NLIGSC, ISEB, St Paul's Girls', Wycombe Abbey, Surbiton High); 12 London independent-school paper packs; worksheets; flash cards; 21 games with 2,979 questions; daily challenges; AI tutoring, AI marking and a writing coach; a parent progress view; a tuition request form; on iOS, Android and web. Not found: video explanations, adaptive difficulty, and scores ranked against other children.";

export const CLOSEST_COMPETITORS = [
  {
    "title": "Exam Happy: the closest match",
    "detail": "Same three platforms, named-school mocks, worksheets, parent reports, and almost the same annual price (£179.99 vs £169.99). The difference: Exam Happy has no AI and says so; 11 Plus Magic has games, flash cards and AI tools"
  },
  {
    "title": "Atom Learning: the benchmark parents compare with",
    "detail": "Same core (target-school mocks and papers, game-style rewards, parent tracking) at over 3x the price (£575.90 a year)"
  },
  {
    "title": "Pip: the closest on games",
    "detail": "A child-first game app at a similar early stage (13 iOS ratings, 500+ Play installs), so its low-cost tactics are the easiest to copy"
  },
  {
    "title": "Eleven Ace: a partial match",
    "detail": "Mocks, diagnostics and a platform plus tuition, like 11 Plus Magic's tuition requests; its game-style app isn't live yet"
  }
];

export const FEATURE_COLUMNS = [
  "Feature",
  "11 Plus Magic",
  "Exam Happy",
  "Atom Learning",
  "Pip",
  "Eleven Ace"
];

export const FEATURE_ROWS = [
  [
    "Timed mocks by exam board",
    "Yes: GL, CEM, CSSE; ISEB and London independents",
    "Yes, built to GL",
    "Yes: GL, CEM/FSCE, ISEB, Quest",
    "Yes, in Pro: GL, Kent, Bucks, Sutton SET, CSSE, Medway, ISEB",
    "Yes: GL, CEM, CSSE, ISEB"
  ],
  [
    "Mocks or papers for a named school",
    "Yes: London 11+ Consortium, NLIGSC, St Paul's Girls', Wycombe Abbey, Surbiton High mocks; 12 London independent paper packs",
    "Yes: 170+ grammar schools",
    "Yes: tailored to the target school",
    "Area formats only",
    "Some (e.g. Chelmsford County High)"
  ],
  [
    "Worksheets",
    "Yes",
    "Yes: worksheet maker, daily worksheets",
    "Printable papers, maths worksheets",
    "No",
    "Topic practice"
  ],
  [
    "Flash cards",
    "Yes",
    "Not found",
    "Not found",
    "Not found",
    "Not found"
  ],
  [
    "Games and rewards",
    "21 games, 2,979 questions; leaderboard in the app",
    "Weekly XP leaderboard with real prizes",
    "Ato companion, coins, unlockable worlds",
    "Streaks, leagues, avatar outfits, boss battles",
    "Game-style app \"opening soon\""
  ],
  [
    "AI tools",
    "AI tutoring, AI marking, writing coach",
    "None; markets \"Zero AI slop\"",
    "Not found",
    "None (generated questions)",
    "Not found"
  ],
  [
    "Marking from a photo",
    "AI marking from a scan",
    "Yes",
    "Yes",
    "No",
    "Not found"
  ],
  [
    "Video explanations",
    "Not found",
    "Yes, every question",
    "Yes",
    "Interactive lessons",
    "Not found"
  ],
  [
    "Adaptive difficulty",
    "Not found",
    "Adaptive worksheets",
    "Yes",
    "Yes",
    "Yes (Learn app)"
  ],
  [
    "Parent progress view",
    "Scores, weak topics, time by subject",
    "Progress reports",
    "Standardised score, compared with other applicants",
    "Pro parent dashboard",
    "Dashboard"
  ],
  [
    "Live tuition",
    "Tuition request form",
    "No (plans for tutors)",
    "Live lessons on Zoom",
    "No",
    "1:1, classes, in-person academies"
  ],
  [
    "Platforms",
    "iOS, Android, web",
    "iOS, Android, web",
    "Web, iOS, Android",
    "iOS, Android, Amazon Fire",
    "Web"
  ],
  [
    "Free entry",
    "Free game rounds, no account; 7-day trial, no card",
    "Free app to start",
    "Free baseline test and GL papers; 5-day trial",
    "Core practice free for good",
    "Free diagnostic assessment"
  ],
  [
    "Price",
    "£29.99/mo; £169.99/yr",
    "From £9.99/mo (Core) or £14.99 (Plus), billed annually",
    "£59.99/mo; £575.90/yr",
    "Pro £7.99/mo; £59/yr",
    "£20/mo; £180/yr"
  ]
];

export const MARKET_LEADER_COLUMNS = [
  "Brand",
  "Facebook",
  "Instagram",
  "YouTube",
  "TikTok",
  "X",
  "Other channels"
];

export const MARKET_LEADER_ROWS = [
  [
    "11 Plus Magic",
    "71 (company page: EdTech-Ltd)",
    "Not found (login wall)",
    "17 subs, 278 videos",
    "7 followers, 78 likes",
    "No account",
    "WhatsApp channel not linked; footer links to EdTech Ltd LinkedIn"
  ],
  [
    "Atom Learning",
    "8.2K",
    "2,960",
    "4.36K subs, 291 videos",
    "4,265 followers, 129.6K likes",
    "895 (support replies only; last post 27 Oct 2025)",
    "LinkedIn 14.2K; free parent webinars; free email course for parents"
  ],
  [
    "CGP",
    "9.7K",
    "21K",
    "7.51K subs, 90 videos",
    "38.4K followers, 1.6M likes",
    "1,468",
    "LinkedIn 2,229"
  ],
  [
    "Exam Papers Plus",
    "2.9K",
    "Not found",
    "2.49K subs, 585 videos",
    "10 followers, 77 likes",
    "744",
    "LinkedIn 1,107; Trustpilot about 1,562 reviews"
  ],
  [
    "Exam Happy",
    "Page active; count not found",
    "Not found",
    "Not found (see note)",
    "7 followers, 10 likes",
    "No account",
    "216 App Store ratings; no social links on its site"
  ],
  [
    "Eleven Plus Exams",
    "Page active; count not found",
    "Account exists; count not found",
    "Not found",
    "511 followers, 1,050 likes",
    "564",
    "Forum: 41,391 members, 797,420 posts; Trustpilot 4.8 (267)"
  ],
  [
    "PiAcademy",
    "1,000",
    "1,746",
    "1.68K subs, 36 videos",
    "Not found",
    "62",
    "LinkedIn 5,045"
  ],
  [
    "Eleven Ace",
    "Page active; count not found",
    "Account exists; count not found",
    "53 subs, 35 videos",
    "Account exists; count not read",
    "No account",
    "Own podcast (episode 1: 373 views)"
  ],
  [
    "Schofield & Sims",
    "Page exists; count not found",
    "Not found",
    "157 subs, 126 videos",
    "Not found",
    "1,172",
    "Books publisher"
  ],
  [
    "11 Plus Guide",
    "Page exists; count not found",
    "Not found",
    "Not found",
    "Not found",
    "21",
    "Free guides and forum"
  ]
];

export const PARENT_COMMUNITIES = [
  {
    "name": "The 11 Plus Journey (Facebook group)",
    "size": "16K+ parents (owner's figure)",
    "why": "Run by a parent since 2015; owner also sells a parent course on Skool"
  },
  {
    "name": "Grammar School Entrance (11plus) info (Facebook group)",
    "size": "Almost 10,000 (listing figure)",
    "why": "Many tutors post tips there"
  },
  {
    "name": "11+, ISEB, SATs, GCSE & A-Level Resource Group (Facebook group)",
    "size": "8,000+ (2020 figure)",
    "why": "Sells advertiser memberships to tutors and brands"
  },
  {
    "name": "Eleven Plus Exams forum",
    "size": "41,391 members",
    "why": "Biggest UK 11+ forum; parents compare mocks and apps here"
  },
  {
    "name": "X, whole platform",
    "size": "276 posts in 7 days",
    "why": "Posts mentioning \"11 plus\" or #11plus, 23–30 Oct 2026; very little parent talk"
  }
];

export const CHANNEL_SCORECARD = [
  {
    "channel": "Free events, webinars, mocks",
    "leader": "Atom (webinars); Eleven Plus Exams (mocks)",
    "theirNumber": "6 free webinars 3–24 Nov; percentile mocks, Trustpilot 4.8 (267)",
    "ours": "Free game rounds only; no free mock or webinar",
    "gap": "No free mock",
    "priority": "P1"
  },
  {
    "channel": "Facebook page + groups",
    "leader": "Atom Learning (runner-up CGP)",
    "theirNumber": "8.2K page followers; groups of 8K–16K parents",
    "ours": "71 followers on the EdTech-Ltd company page",
    "gap": "About 115x",
    "priority": "P1"
  },
  {
    "channel": "App Store / Play Store",
    "leader": "Exam Happy",
    "theirNumber": "216 iOS ratings (4.48); #1 for \"11 plus\"",
    "ours": "1 rating; not in top 10; 10+ Play installs",
    "gap": "216x ratings",
    "priority": "P1"
  },
  {
    "channel": "Referrals, affiliates, tutors",
    "leader": "Atom Learning",
    "theirNumber": "£30/£30 parent referral; 15% recurring for tutors; 1,000+ schools",
    "ours": "None",
    "gap": "Missing",
    "priority": "P1"
  },
  {
    "channel": "Email newsletter",
    "leader": "Atom Learning",
    "theirNumber": "Free 5-lesson daily email course for parents",
    "ours": "Trial reminder emails only",
    "gap": "No lead magnet",
    "priority": "P2"
  },
  {
    "channel": "YouTube",
    "leader": "Exam Papers Plus (reach); Atom (organic)",
    "theirNumber": "EPP 10.1M lifetime views; Atom 4.36K subs, 1.35M views",
    "ours": "17 subs, 3,049 lifetime views",
    "gap": "Atom has about 440x the views",
    "priority": "P2"
  },
  {
    "channel": "WhatsApp channel / community",
    "leader": "No national leader; local tutors",
    "theirNumber": "Brilliant Tutors Academy: free resources every Friday",
    "ours": "Channel exists but not linked anywhere",
    "gap": "Open lane",
    "priority": "P2"
  },
  {
    "channel": "Google search / SEO + blog",
    "leader": "Atom Learning (runner-up EPP)",
    "theirNumber": "1,608 URLs in sitemap, 721 blog posts",
    "ours": "18 URLs, 0 blog posts",
    "gap": "About 89x pages",
    "priority": "P2"
  },
  {
    "channel": "TikTok",
    "leader": "CGP; Atom (11+ specialist)",
    "theirNumber": "38.4K; 4,265 followers",
    "ours": "7 followers",
    "gap": "About 600x vs Atom",
    "priority": "P3"
  },
  {
    "channel": "Instagram",
    "leader": "CGP; Atom (11+ specialist)",
    "theirNumber": "21K; 2,960 followers",
    "ours": "Not found (login wall)",
    "gap": "Not measurable",
    "priority": "P3"
  },
  {
    "channel": "Parent forums / communities",
    "leader": "Eleven Plus Exams",
    "theirNumber": "41,391 forum members, 797,420 posts",
    "ours": "No mentions found",
    "gap": "Not present",
    "priority": "P3"
  },
  {
    "channel": "Paid ads (Meta / Google / YouTube)",
    "leader": "Atom (documented); EPP (video reach)",
    "theirNumber": "EPP promo videos 5.2M and 2.4M views",
    "ours": "Meta Pixel installed; no ads verified",
    "gap": "Not verifiable",
    "priority": "P3"
  }
];

export const SCORECARD_NOTE = "LinkedIn: Atom has 14.2K followers, but it's a school and hiring audience, so it only matters if you go after school licences. Pinterest: no UK 11+ competitor was found using it. X: skip (276 posts about the 11+ across the whole platform in a week).";

export const COMMON_THREAD = "Every 11 Plus Magic channel posts content for children (topic lessons). The leaders post for parents: exam dates, school formats, “what if my child doesn't pass”, and free tests. Parents are the ones who pay and the ones who follow.";

export const COMPETITOR_MARKETING = [
  {
    "name": "Exam Happy",
    "role": "Closest product match",
    "why": "Same three platforms, named-school mocks, worksheets, parent reports, and almost the same annual price (£179.99 vs £169.99). The difference: Exam Happy has no AI and says so; 11 Plus Magic has games, flash cards and AI tools",
    "aspects": [
      {
        "label": "Main message",
        "value": "\"Saving you time and stress with 11+ prep. Trusted by 10,000+ UK parents.\" Questions \"written by UK teachers. Zero AI slop.\""
      },
      {
        "label": "Who they target",
        "value": "Parents aiming at a named grammar (Queen Elizabeth's, Tiffin, Henrietta Barnett, St Olave's); also tutors and schools"
      },
      {
        "label": "How they show the product",
        "value": "Feature blocks for photo marking, video solutions, printable PDFs; app download page for all devices"
      },
      {
        "label": "Proof",
        "value": "\"4.7 out of 5 from 250+ parent reviews\" (own claim); 216 App Store ratings (4.48); prize winners quoted"
      },
      {
        "label": "Funnel",
        "value": "App Store search (#1 for \"11 plus\") or school or tutor, then free download, then pick the target grammar, then a paid plan"
      },
      {
        "label": "Price framing",
        "value": "\"From £9.99/month\"; \"Less than half an hour with a tutor, for the whole month\"; save up to 60% annually"
      },
      {
        "label": "Key channels and numbers",
        "value": "App Store 216 ratings, #1; Play 10K+ installs; TikTok 7; LinkedIn 26; no social links on its site"
      }
    ]
  },
  {
    "name": "Atom Learning",
    "role": "UK 11+ market leader",
    "why": "Same core (target-school mocks and papers, game-style rewards, parent tracking) at over 3x the price (£575.90 a year)",
    "aspects": [
      {
        "label": "Main message",
        "value": "\"Tailored exam prep.\" \"In 2025, 89% of Atom Home users got offered a place at their top-choice school.\" 350,000 families, 2,000+ schools"
      },
      {
        "label": "Who they target",
        "value": "Parents of Years 3–6 for grammar and independent entry; schools"
      },
      {
        "label": "How they show the product",
        "value": "Feature pages (practice papers, progress tracking), platform demo webinars, free GL papers"
      },
      {
        "label": "Proof",
        "value": "89% top-choice claim; Trustpilot about 4.4–4.5 from 1,000+ reviews (per Pip); named school partners"
      },
      {
        "label": "Funnel",
        "value": "Blog, ads, webinars and free papers, then a 5-day email course, then a 5-day trial, then a paid plan, then referral"
      },
      {
        "label": "Price framing",
        "value": "Clear tiers shown before sign-up; 20% off annual; discount codes; free for Pupil Premium"
      },
      {
        "label": "Key channels and numbers",
        "value": "Facebook 8.2K; YouTube 4.36K subs, 1.35M views; TikTok 4,265; 1,608 site pages"
      }
    ]
  },
  {
    "name": "Pip",
    "role": "Closest on games",
    "why": "A child-first game app at a similar early stage (13 iOS ratings, 500+ Play installs), so its low-cost tactics are the easiest to copy",
    "aspects": [
      {
        "label": "Main message",
        "value": "\"Free 11+ and SATs practice that adapts to your child.\" No ads, no account, \"no free trial traps\""
      },
      {
        "label": "Who they target",
        "value": "Parents wanting daily practice that a child does alone; privacy-minded families"
      },
      {
        "label": "How they show the product",
        "value": "Animated phone mockups, tablet screens, a \"Today's path\" walkthrough, a table against papers and tutors"
      },
      {
        "label": "Proof",
        "value": "Real App Store, Google Play and TikTok reviews on the homepage"
      },
      {
        "label": "Funnel",
        "value": "Comparison articles and app stores, then the free app and daily streak, then Pro (mocks, parent dashboard) with a 7-day trial"
      },
      {
        "label": "Price framing",
        "value": "Free for good; Pro £7.99/mo or £59/yr"
      },
      {
        "label": "Key channels and numbers",
        "value": "iOS 13 ratings (4.15); Play 500+ installs; YouTube 87 subs, 394 videos, 23,021 views; Instagram, TikTok, Facebook counts not found"
      }
    ]
  },
  {
    "name": "Eleven Ace",
    "role": "Partial match (platform + tuition)",
    "why": "Mocks, diagnostics and a platform plus tuition, like 11 Plus Magic's tuition requests; its game-style app isn't live yet",
    "aspects": [
      {
        "label": "Main message",
        "value": "\"Expert 11 Plus Preparation. Grammar School Success Starts Here.\" 300+ families, 12+ locations"
      },
      {
        "label": "Who they target",
        "value": "Local families (Essex and 12+ locations) wanting tuition plus mocks"
      },
      {
        "label": "How they show the product",
        "value": "Testimonial videos, workshop and mock-day videos, a podcast"
      },
      {
        "label": "Proof",
        "value": "Named parent and child testimonials; \"reviewed by qualified 11+ examiners\""
      },
      {
        "label": "Funnel",
        "value": "Free diagnostic and report, then a crash course, 1:1 tuition, academy or platform"
      },
      {
        "label": "Price framing",
        "value": "£20/£100/£180; coaching from £30 a session; £24 mock-year coupon"
      },
      {
        "label": "Key channels and numbers",
        "value": "YouTube 53 subs; Facebook and Instagram counts not found; game app waitlist"
      }
    ]
  }
];

export const CHANNEL_PLAYBOOKS = [
  {
    "id": "events",
    "name": "Free events, webinars and mock exams",
    "lead": "For free events, Atom Learning is the best UK 11+ prep brand for webinars, and Eleven Plus Exams is the best for mock exams. To reach that level, 11 Plus Magic needs a free first step that parents can join, share and talk about.",
    "evidence": [
      "Atom lists 6 free live parent webinars between 3 and 24 Nov 2026: GL roadmap (3 Nov), Quest (10 Nov), ISEB Pre-Test (17 Nov), second-stage exams and confidence (18 Nov), and one on 24 Nov. Replays go to YouTube: https://www.atomlearning.com/webinars",
      "Atom also gives away a free baseline test and free full-length GL papers: https://www.atomlearning.com/features/11-plus-practice-papers",
      "Eleven Plus Exams runs in-person and online mocks with a percentile score and cohort comparison, mid-March to mid-September. Its Trustpilot rating is 4.8 from 267 reviews (per Pip's comparison page)",
      "Eleven Ace offers a free diagnostic, and filmed an in-person mock at Chelmsford on 11 July 2026 (the video got 296 views)"
    ],
    "gap": [
      {
        "metric": "Free live webinars, Nov 2026",
        "leader": "6 (Atom)",
        "ours": "0"
      },
      {
        "metric": "Free test before sign-up",
        "leader": "Baseline test plus free GL papers (Atom)",
        "ours": "Free game rounds, but no free mock"
      },
      {
        "metric": "Mock with ranking against other children",
        "leader": "Yes (Eleven Plus Exams)",
        "ours": "No"
      }
    ],
    "todo": [
      "Launch a free 20–30 minute mini-mock with a score report, and make it the one link in every post and bio",
      "Run 1 free parent webinar a month (\"Year 4: where to start\", \"CSSE explained\"). Post the replay on YouTube and cut 3 Shorts from it",
      "Run a virtual mock day every quarter with ranking against other entrants. Charge a small fee for non-subscribers; subscribers get it free",
      "Announce each event in Facebook groups, on WhatsApp and by email 2 weeks ahead"
    ],
    "target": "300 mini-mock completions, 2 webinars with 30+ live parents each, 1 virtual mock day with 100 entrants",
    "effort": "Medium to high",
    "priority": "P1, start first: every other channel needs this as its call to action"
  },
  {
    "id": "facebook",
    "name": "Facebook page and parent groups",
    "lead": "On Facebook, Atom Learning is the best UK 11+ prep brand. CGP has more page followers (9.7K) but covers all ages. To reach that level, 11 Plus Magic needs a page parents recognise as 11 Plus Magic, plus a steady, helpful presence in the big parent groups.",
    "evidence": [
      "Atom's page has 8.2K followers. The bio leads with proof (\"87% of Atom kids got into their chosen school\"), and it posts short explainer videos (e.g. a CAT4 explainer) and product videos: https://www.facebook.com/weareatomlearning/",
      "Parent groups are where buying decisions happen: The 11 Plus Journey has 16K+ parents (owner's figure), Grammar School Entrance (11plus) info almost 10,000, and the 11+ Resource Group 8,000+, which sells advertiser memberships",
      "Parents name and compare brands in groups, e.g. \"Has anyone else found Atom Learning more frustrating (and costly) than helpful\" in the 11+ Vocab and other resources group",
      "Exam Papers Plus uses its page for sales and dates (\"35% off\" summer sale, \"Mock exam dates filling up\")",
      "Posting frequency can't be read without logging in to Facebook, so it's not found (30 Oct 2026)"
    ],
    "gap": [
      {
        "metric": "Page followers",
        "leader": "8.2K (Atom)",
        "ours": "71"
      },
      {
        "metric": "Page name matches what parents search for",
        "leader": "Yes, \"Atom Learning\"",
        "ours": "No, company page \"EdTech-Ltd\""
      },
      {
        "metric": "Visible in parent groups",
        "leader": "Discussed by name",
        "ours": "No mentions found"
      }
    ],
    "todo": [
      "EdTech-Ltd is the company and 11 Plus Magic is one of its products. Either open a dedicated 11 Plus Magic page, or brand the current page \"11 Plus Magic by EdTech-Ltd\" with the 11 Plus Magic logo and a button linking to the free mock",
      "Post 3 times a week: a puzzle with the answer in the comments, an exam-date reminder by area, and a parent tip",
      "Join 5 large groups. Answer 3–5 questions a day as the founder, and only share a link when someone asks",
      "Test one paid placement in the 11+ Resource Group, and share every webinar and mock day there",
      "Pin a post with 3 parent quotes (with permission) and the free mock link"
    ],
    "target": "500 page followers, active in 5 groups, 30 trials tracked to Facebook with UTM links",
    "effort": "Medium (daily time, no budget needed)",
    "priority": "P1"
  },
  {
    "id": "apps",
    "name": "App Store and Play Store",
    "lead": "In the app stores, Exam Happy is the best UK 11+ prep brand. To reach that level, 11 Plus Magic needs reviews and keyword-rich listings.",
    "evidence": [
      "Exam Happy has 216 iOS ratings at 4.48 and ranks #1 for \"11 plus\" in Apple's search API (UK, 30 Oct 2026): https://apps.apple.com/gb/app/exam-happy-11-practice/id1552633179",
      "On Google Play, Exam Happy has 10,000+ installs and 4.45 from 75 ratings (29 Oct report)",
      "Atom ranks #9 for \"11 plus\" with 27 ratings at 3.70, so even big brands are beatable here"
    ],
    "gap": [
      {
        "metric": "iOS ratings",
        "leader": "216 (4.48)",
        "ours": "1 (5.0)"
      },
      {
        "metric": "iOS position for \"11 plus\"",
        "leader": "#1",
        "ours": "Not in top 10"
      },
      {
        "metric": "Google Play installs",
        "leader": "10,000+",
        "ours": "10+"
      }
    ],
    "todo": [
      "Add the in-app review prompt after a good mock score or a 3-day streak",
      "Personally ask trial and paying parents for an honest review",
      "Play title \"11 Plus Magic: 11+ Mock Exams\"; screenshots that name GL, CEM, CSSE, ISEB and London schools",
      "Reply to every review"
    ],
    "target": "50 ratings across both stores, top 10 on iOS for \"11 plus\", 100+ Play installs",
    "effort": "Low",
    "priority": "P1"
  },
  {
    "id": "referrals",
    "name": "Referrals, affiliates and tutor partnerships",
    "lead": "For referrals and partnerships, Atom Learning is the best UK 11+ prep brand. Exam Happy is runner-up with tutor plans. To reach that level, 11 Plus Magic needs to pay parents, tutors and bloggers to bring families in.",
    "evidence": [
      "Parent referral: give £30, get £30: https://www.atomlearning.com/referrals",
      "Tutors earn 15% of a referred family's subscription every month, and the family gets 10% off the first payment: https://www.atomlearning.com/tutor-terms",
      "Mum-blogger discount codes: Emma and 3 (10% code), Mamma Prada (2026 code post), Mums in the Wood",
      "Schools: Atom Prime is free in 1,000+ schools. Maidstone Grammar School partnered with Atom in Feb 2025 to give Atom Home free to Pupil Premium children"
    ],
    "gap": [
      {
        "metric": "Parent referral reward",
        "leader": "£30 / £30",
        "ours": "None"
      },
      {
        "metric": "Tutor commission",
        "leader": "15% recurring",
        "ours": "None"
      },
      {
        "metric": "Blogger codes",
        "leader": "3+ found",
        "ours": "None"
      },
      {
        "metric": "School partnerships",
        "leader": "1,000+ schools",
        "ours": "None"
      }
    ],
    "todo": [
      "Give a free month, get a free month, shown after every good score and in emails",
      "Tutor affiliate: 15–20% recurring plus a free tutor login",
      "Send 10 UK parenting bloggers a free year and a unique code",
      "Offer 2 local primary schools free Pupil Premium places, as Atom does"
    ],
    "target": "20 tutors signed up, 5 blogger codes live, 2 schools trialling",
    "effort": "Medium",
    "priority": "P1"
  },
  {
    "id": "email",
    "name": "Email newsletter",
    "lead": "For email, Atom Learning is the best UK 11+ prep brand. To reach that level, 11 Plus Magic needs a free email course that turns interested parents into trials.",
    "evidence": [
      "Atom's free \"11+ course for parents\" sends one lesson a day for 5 days (what's on your local 11+, registration deadlines, preparing, results day, next steps), then pitches the subscription: https://resources.atomlearning.co.uk/free-11-course-for-parents",
      "Webinar sign-ups and free-paper downloads also feed Atom's list",
      "Exam Papers Plus sends weekly summary emails after its free diagnostic (29 Oct report)",
      "Neither brand publishes its list size, so list sizes are not found (30 Oct 2026)"
    ],
    "gap": [
      {
        "metric": "Free email course",
        "leader": "5 daily lessons",
        "ours": "None"
      },
      {
        "metric": "Newsletter sign-up outside the trial",
        "leader": "Yes",
        "ours": "None found"
      }
    ],
    "todo": [
      "A 5-day email course by exam type (GL, CSSE, London independents), offered after the mini-mock",
      "A weekly Sunday newsletter: this week's plan, 1 free worksheet, upcoming events",
      "A 7-email trial sequence that ends with the annual plan and the referral offer"
    ],
    "target": "500 subscribers, with 15% starting a trial",
    "effort": "Medium",
    "priority": "P2"
  },
  {
    "id": "youtube",
    "name": "YouTube",
    "lead": "On YouTube, Exam Papers Plus is the best UK 11+ prep brand for reach, and Atom Learning is the best for organic parent content. To reach that level, 11 Plus Magic needs parent-facing Shorts and explainers on a steady schedule.",
    "evidence": [
      "Exam Papers Plus: 2.49K subscribers, 585 videos, 10.1M lifetime views. Its top videos are product promos: \"11+ Exam Papers - School Search\" (5.2M views) and a second School Search video (2.4M). On a channel this size, that pattern suggests they ran as ads (inferred): https://www.youtube.com/watch?v=xDxy8eD2UZs",
      "EPP posted about 15 #11plus Shorts in Oct–Nov 2025, getting 196–2,224 views each",
      "Atom: 4.36K subscribers, 291 videos, 1.35M lifetime views. Top organic videos: \"NVR Techniques: Nets and Cubes\" (28K) and \"Preparing for School Interviews\" (24K): https://www.youtube.com/watch?v=faLjNlsQDJ0",
      "Atom uploaded 15 videos between 8 and 27 Oct 2026, all parent explainers or webinar replays (\"Grammar school myths\", 804 views)",
      "PiAcademy's top video is a parent testimonial, \"How we aced the 11+ Exams\" (53K): https://www.youtube.com/watch?v=D2-gLF2Rp_8"
    ],
    "gap": [
      {
        "metric": "Subscribers",
        "leader": "4.36K (Atom)",
        "ours": "17"
      },
      {
        "metric": "Lifetime views",
        "leader": "1.35M (Atom); 10.1M (EPP)",
        "ours": "3,049 (since May 2026)"
      },
      {
        "metric": "Best video",
        "leader": "28K organic (Atom)",
        "ours": "154 (NVR puzzle Short)"
      },
      {
        "metric": "Upload rhythm",
        "leader": "15 in 20 days, spread out (Atom)",
        "ours": "Bulk uploads (e.g. 15 lessons on 19 Oct)"
      }
    ],
    "todo": [
      "5 Shorts a week: \"Can your child crack this?\" puzzles, answer at the end",
      "1 parent explainer a week (\"CSSE vs GL\", \"Year 4 plan\", \"What if my child doesn't pass?\"), plus webinar replays",
      "1 parent testimonial video a month (PiAcademy's gets 53K views)",
      "Put \"11 Plus\" in every title, use playlists by exam board, put the free mock link in every description, and unlist the \"analytics\" clip",
      "Later, run the best Short as a YouTube ad, as EPP appears to"
    ],
    "target": "300 subscribers, 20,000 views over the period, 1 video above 2,000 views",
    "effort": "Medium",
    "priority": "P2"
  },
  {
    "id": "whatsapp",
    "name": "WhatsApp channel and community",
    "lead": "On WhatsApp, no national 11+ brand leads. Atom uses WhatsApp only for support (+44 7400 511797). Local tutors run the best communities. To reach that level, 11 Plus Magic needs to make its channel visible and give parents a weekly reason to stay.",
    "evidence": [
      "Brilliant Tutors Academy (Reading) posts its WhatsApp community link publicly and shares free resources every Friday, plus mock updates and offers",
      "A-One Tuition lists \"11+ Grammar Entrance\" and \"11+ Private School Entrance\" WhatsApp groups: https://aonetuition.co.uk/groups/",
      "The 11 Plus Journey uses WhatsApp groups for its paying families",
      "Member counts for these groups are not public, so not found (30 Oct 2026)"
    ],
    "gap": [
      {
        "metric": "Join link posted publicly",
        "leader": "Yes (local tutors)",
        "ours": "No: the footer links only to LinkedIn, YouTube, Facebook, Instagram and TikTok"
      },
      {
        "metric": "Weekly free resource",
        "leader": "Every Friday",
        "ours": "None"
      }
    ],
    "todo": [
      "Link the channel in the site footer, app home screen, emails and every bio",
      "3 posts a week: Monday puzzle, Wednesday tip, Sunday 10-question challenge",
      "Use the channel first for mock-day and webinar reminders"
    ],
    "target": "300 channel followers",
    "effort": "Low",
    "priority": "P2 (no big brand owns it yet)"
  },
  {
    "id": "seo",
    "name": "Google search / SEO and blog",
    "lead": "In Google search, Atom Learning is the best UK 11+ prep brand. Exam Papers Plus is runner-up. To reach that level, 11 Plus Magic needs pages Google can read for every exam, area and school parents search for.",
    "evidence": [
      "Atom's sitemap lists 1,608 URLs: 721 blog posts, 389 primary free-resource pages, 163 grammar-school pages and 155 Pupil Premium pages: https://www.atomlearning.com/sitemap.xml",
      "Atom's practice-papers page shows in the top results for \"11 plus mock exam online\"",
      "A third-party listing estimates Atom's site at 968K monthly visits",
      "EPP's sitemap lists 1,328 posts and about 2,049 product pages, many named after schools",
      "Searches for free papers are dominated by free sites (MyFreeSchool, Owl Tutors, WAJD, 11+ Daily, CGP), so that's a hard term to win"
    ],
    "gap": [
      {
        "metric": "URLs in sitemap",
        "leader": "1,608 (Atom)",
        "ours": "18"
      },
      {
        "metric": "Blog posts",
        "leader": "721 (Atom)",
        "ours": "0"
      },
      {
        "metric": "School and area pages",
        "leader": "163 grammar-school pages (Atom)",
        "ours": "None"
      }
    ],
    "todo": [
      "Pre-render the site so Google sees the text",
      "Build 12 school and area pages (Essex CSSE, Sutton SET, London Consortium, Kent, Bucks, Birmingham), each with a free sample question and the mini-mock",
      "2 parent guides a week (exam dates, formats, \"Atom vs Exam Happy vs 11 Plus Magic\")"
    ],
    "target": "30 new pages indexed, with 5 school-name searches in the top 20",
    "effort": "High",
    "priority": "P2"
  },
  {
    "id": "tiktok",
    "name": "TikTok",
    "lead": "On TikTok, CGP is the biggest UK 11+ publisher, and Atom Learning is the best 11+ specialist. To reach that level, 11 Plus Magic needs to post its Shorts there 5 times a week with parent hooks.",
    "evidence": [
      "CGP: 38.4K followers and 1.6M likes (covers all ages): https://www.tiktok.com/@cgpbooks",
      "Atom: 4,265 followers and 129.6K likes. Its blog also promotes a TikTok-style timing challenge: https://www.atomlearning.com/blog/improve-timing-11-plus",
      "Everyone else is tiny: Eleven Plus Exams 511, Exam Papers Plus 10, Exam Happy 7",
      "Posting frequency and video views couldn't be read (TikTok blocked repeated reads), so not found (30 Oct 2026)"
    ],
    "gap": [
      {
        "metric": "Followers",
        "leader": "4,265 (Atom)",
        "ours": "7"
      },
      {
        "metric": "Likes",
        "leader": "129.6K (Atom)",
        "ours": "78"
      }
    ],
    "todo": [
      "Post every YouTube Short to TikTok, 5 a week",
      "Parent hooks: \"Would your Year 5 get this right?\" and \"Could you pass the 11+?\"",
      "Free mock link in the bio"
    ],
    "target": "500 followers (about 12% of Atom's)",
    "effort": "Low (reuses Shorts)",
    "priority": "P3"
  },
  {
    "id": "instagram",
    "name": "Instagram",
    "lead": "On Instagram, CGP is the biggest UK 11+ publisher, and Atom Learning is the best 11+ specialist. To reach that level, 11 Plus Magic needs Reels and freebie posts that point to one free offer.",
    "evidence": [
      "CGP: 21K followers, 571 posts (Endole listing)",
      "Atom: 2,960 followers, 454 posts, verified, with a \"Start your FREE trial\" bio and Linktree. Third-party listings say 7,005 and 10.4K, so treat the count as uncertain",
      "Atom posts free-question giveaways, e.g. free CEM Select practice questions: https://www.instagram.com/atomlearning/p/C6HFn0qx3N8/",
      "PiAcademy: 1,746 followers; posts tip Reels (\"Top 5 Tips to Boost Scores in 11+ Maths\")"
    ],
    "gap": [
      {
        "metric": "Followers",
        "leader": "2,960 (Atom)",
        "ours": "Not found (login wall)"
      },
      {
        "metric": "Bio offer",
        "leader": "Free trial (Atom)",
        "ours": "Not linked to a free offer"
      }
    ],
    "todo": [
      "4 Reels a week (the same Shorts) and 2 carousels (exam dates by area, \"what's on the paper\")",
      "Daily stories with puzzle polls",
      "Bio link to the free mini-mock"
    ],
    "target": "300 followers",
    "effort": "Low to medium (reuses Shorts)",
    "priority": "P3"
  },
  {
    "id": "forums",
    "name": "Parent forums and communities",
    "lead": "In parent forums, Eleven Plus Exams is the best UK 11+ prep brand, because it owns the biggest forum. To reach that level, 11 Plus Magic needs to be a helpful, named voice where parents compare apps.",
    "evidence": [
      "Eleven Plus Exams forum: 41,391 members, 797,420 posts: https://www.elevenplusexams.co.uk/forum/11plus/index.php",
      "Parents compare providers there, e.g. \"Atom learning mocks Latymer and HBS\": https://www.elevenplusexams.co.uk/forum/11plus/viewtopic.php?t=66003",
      "Atom is also discussed on Reddit r/11plus and Trustpilot. Mumsnet thread counts were not checked"
    ],
    "gap": [
      {
        "metric": "Forum members",
        "leader": "41,391 (own forum)",
        "ours": "No forum"
      },
      {
        "metric": "Brand mentions found",
        "leader": "Many (Atom, EPP)",
        "ours": "None found"
      }
    ],
    "todo": [
      "Open a clearly named founder account on the Eleven Plus Exams forum, Mumsnet and r/11plus",
      "Answer 3 questions a week; mention 11 Plus Magic only when it fits",
      "Offer the free mini-mock when parents ask about mocks"
    ],
    "target": "30 helpful answers and 5 threads mentioning 11 Plus Magic",
    "effort": "Low to medium",
    "priority": "P3"
  },
  {
    "id": "ads",
    "name": "Paid ads (Meta, Google, YouTube)",
    "lead": "For paid ads, Atom Learning is the best-documented UK 11+ advertiser, and Exam Papers Plus shows the most visible video ad reach. To reach that level, 11 Plus Magic should only spend once the free mock and reviews are in place.",
    "evidence": [
      "The Meta Ad Library and TikTok Creative Center need a logged-in browser, so which ads are running now is not verified (30 Oct 2026): https://www.facebook.com/ads/library/",
      "An ex-Atom designer's case study says Atom cut cost per acquisition by 22% and then \"scale[d] paid ads aggressively during peak season\": https://joshuasantoso.com/work/al-website",
      "A third-party tech listing shows Atom using Meta, Google and Microsoft ads and the TikTok pixel",
      "EPP's promo videos have 5.2M and 2.4M views, and Pretest Plus promos 291K–440K, on a 2.49K-subscriber channel (inferred ads). The Meta Pixel is on the EPP, Pretest Plus, PiAcademy and Eleven Ace sites"
    ],
    "gap": [
      {
        "metric": "Evidence of ad spend",
        "leader": "Case study plus ad pixels (Atom); video views (EPP)",
        "ours": "Meta Pixel installed; no ads verified"
      },
      {
        "metric": "Landing offer for ads",
        "leader": "Free trial, free papers (Atom)",
        "ours": "7-day trial; free game rounds"
      }
    ],
    "todo": [
      "Wait until the free mini-mock and 30+ reviews are live",
      "Retarget site visitors with the best-performing Short",
      "Geo-target grammar areas on Meta, and run Google Search ads on \"[school] mock exam\" terms",
      "Start with a small daily test and stop any ad whose cost per trial is too high"
    ],
    "target": "A measured cost per trial from one 4-week test",
    "effort": "Medium",
    "priority": "P3 (after P1 work)"
  }
];

export const POSITIONING_LINE = "Mocks and papers in the style of your child's exact school, plus games they'll actually ask to play. iPhone, Android and web, from £14 a month.";

export const POSITIONING_NOTES = [
  "Against Atom (for comparison pages): the same school-specific prep for under a third of the price (£169.99 vs £575.90 a year)",
  "Against Exam Happy: London independent-school papers (St Paul's, Habs, NLCS, Westminster Under, Latymer and more), not only grammars, plus games and flash cards",
  "Against Pip: real school-style mocks and papers, not just daily drills",
  "Not \"the only\": Atom also combines game-style rewards with target-school papers, so don't claim to be unique",
  "Lead with schools and games; keep AI as a helper (\"instant help when they're stuck\"), because Exam Happy markets against AI content"
];

export const FUNNEL_COLUMNS = [
  "Stage",
  "Atom",
  "Exam Happy",
  "Pip",
  "Eleven Ace",
  "11 Plus Magic now",
  "Build next"
];

export const FUNNEL_ROWS = [
  [
    "First touch",
    "721 blog posts, ads, webinars, schools",
    "App Store #1, free school licences, tutors",
    "App stores, comparison articles, a free competition",
    "Free diagnostic, workshops, academies",
    "Small social channels; 18-page site; free games page not promoted",
    "Free games and mini-mock as the one link everywhere; school pages"
  ],
  [
    "Free entry point",
    "Free baseline test, free GL papers, email course",
    "Free app download",
    "Free core app",
    "Free diagnostic with report",
    "Free game rounds (no account); daily challenge needs login to answer",
    "Free mini-mock with a parent report, plus free games"
  ],
  [
    "Onboarding",
    "Target school and exam date set a tailored plan",
    "Pick the target grammar for school mocks",
    "Pick the exam area and a daily pace (5, 10, 20 or 30)",
    "Diagnostic report shows gaps",
    "Parent and child accounts; first-run steps not checked",
    "Ask for target school and exam date on sign-up; show a plan and the first mock"
  ],
  [
    "Trial",
    "5 days",
    "Free to start (trial length not found)",
    "7-day Pro trial",
    "Not found",
    "7 days, no card",
    "Keep 7 days; email day 1, 3, 5 and 7 with the child's results"
  ],
  [
    "Conversion",
    "Pricing shown up front (its case study: +38% sign-ups)",
    "\"From £9.99\"; tutor-hour comparison",
    "Low price; \"no trial traps\"",
    "Coupons and course offers",
    "£29.99 monthly shown first",
    "Lead with \"from £14.17 a month\"; one-off school pack as a cheaper first buy"
  ],
  [
    "Referral and retention",
    "£30/£30 referral; tutors 15%; schools",
    "Weekly prize leaderboard; tutor plans; free schools",
    "Streaks, leagues, outfit drops, competitions",
    "Testimonials, podcast",
    "Leaderboard in the app; no referral",
    "Free month for both; weekly leaderboard prizes; tutor affiliate"
  ]
];

export const ROADMAP_PHASES = [
  {
    "id": "phase1",
    "title": "Phase 1",
    "when": "0–30 days",
    "goal": "Get the front door and proof ready",
    "items": [
      {
        "id": "p1-free-games-front-door",
        "week": 1,
        "action": "Make the free games the front door: \"Play a free 11+ game\" in every post and bio; after a round, offer a free parent account to save the score",
        "copiedFrom": "Pip (free core), Atom (free papers)",
        "effort": "Low",
        "cost": "£0 (already built)",
        "target": "500 game players, 150 free accounts"
      },
      {
        "id": "p1-free-mini-mock",
        "week": 4,
        "action": "Add a free 20-minute school-style mini-mock with an emailed parent report",
        "copiedFrom": "Atom baseline test; Eleven Ace free diagnostic",
        "effort": "Medium",
        "cost": "£0",
        "target": "300 completions"
      },
      {
        "id": "p1-lead-with-monthly-price",
        "week": 1,
        "action": "Lead with \"from £14.17 a month\" on the site and paywall; show the school paper packs as a cheaper first buy",
        "copiedFrom": "Exam Happy \"from £9.99\"; Atom pricing-first (+38% sign-ups)",
        "effort": "Low",
        "cost": "£0",
        "target": "Trial-to-paid rate tracked weekly"
      },
      {
        "id": "p1-homepage-store-proof",
        "week": 3,
        "action": "Put proof on the homepage and stores: 3–5 parent quotes, a 60-second demo video, the list of schools covered",
        "copiedFrom": "Pip shows store and TikTok reviews; PiAcademy's testimonial video has 53K views",
        "effort": "Low",
        "cost": "£0",
        "target": "3 quotes and 1 demo video live"
      },
      {
        "id": "p1-app-store-reviews",
        "week": 2,
        "action": "App stores: review prompt after a good score; keyword titles; screenshots of games and school papers",
        "copiedFrom": "Exam Happy: 216 ratings, #1",
        "effort": "Low",
        "cost": "£0",
        "target": "30 ratings"
      },
      {
        "id": "p1-facebook-page-brand",
        "week": 2,
        "action": "Brand the Facebook page \"11 Plus Magic by EdTech-Ltd\" (or open a dedicated page) with the logo and a free-game or mock button",
        "copiedFrom": "Atom page: 8.2K followers",
        "effort": "Low",
        "cost": "£0",
        "target": "300 followers"
      },
      {
        "id": "p1-utm-tracking",
        "week": 1,
        "action": "UTM tags on every link, and the admin Marketing analytics page live",
        "copiedFrom": "Atom tracks cost per acquisition",
        "effort": "Medium",
        "cost": "£0",
        "target": "Every sign-up has a source"
      }
    ]
  },
  {
    "id": "phase2",
    "title": "Phase 2",
    "when": "1–3 months",
    "goal": "Add referral, email and content engines",
    "items": [
      {
        "id": "p2-referral-affiliate",
        "week": 5,
        "action": "Refer a friend (free month each) and a tutor affiliate scheme (15% recurring)",
        "copiedFrom": "Atom: £30/£30 and 15% for tutors",
        "effort": "Medium",
        "cost": "Paid only on sales",
        "target": "20 tutors; 10% of new paid customers from referrals"
      },
      {
        "id": "p2-weekly-leaderboard",
        "week": 8,
        "action": "Weekly leaderboard challenge with small prizes, using the existing in-app leaderboard",
        "copiedFrom": "Exam Happy prize leaderboard",
        "effort": "Medium",
        "cost": "Prize budget is the owner's call (not grounded)",
        "target": "Weekly active children tracked"
      },
      {
        "id": "p2-email-course-webinar",
        "week": 6,
        "action": "5-day email course and a monthly parent webinar",
        "copiedFrom": "Atom: 5-lesson course; 6 webinars in Nov 2026",
        "effort": "Medium",
        "cost": "£0 (tool cost not checked)",
        "target": "500 email subscribers; 2 webinars"
      },
      {
        "id": "p2-school-comparison-pages",
        "week": 10,
        "action": "12 school pages, one per London paper pack you sell, plus a \"Atom vs Exam Happy vs Pip vs 11 Plus Magic\" page",
        "copiedFrom": "Atom: 163 grammar-school pages; Pip's comparison articles",
        "effort": "High",
        "cost": "£0",
        "target": "15 new pages indexed"
      },
      {
        "id": "p2-writing-competition",
        "week": 12,
        "action": "Free creative-writing competition judged with the Writing Coach",
        "copiedFrom": "Pip SPARK competition",
        "effort": "Medium",
        "cost": "Prize budget is the owner's call",
        "target": "100 entries"
      },
      {
        "id": "p2-shorts-reels",
        "week": 7,
        "action": "5 Shorts a week, reposted to TikTok and Reels (games and school-paper puzzles)",
        "copiedFrom": "Atom and EPP Shorts",
        "effort": "Medium",
        "cost": "£0",
        "target": "YouTube 300 subs; TikTok 500 followers"
      }
    ]
  },
  {
    "id": "phase3",
    "title": "Phase 3",
    "when": "3–6 months",
    "goal": "Events, schools, tuition and paid growth",
    "items": [
      {
        "id": "p3-virtual-mock-days",
        "week": 14,
        "action": "Virtual mock days with ranking: London independents before January exams, grammars in spring and summer",
        "copiedFrom": "Eleven Plus Exams percentile mocks; Eleven Ace mock day",
        "effort": "High",
        "cost": "£0 (online)",
        "target": "100 entrants per mock day"
      },
      {
        "id": "p3-school-licences",
        "week": 18,
        "action": "Free school and Pupil Premium licences",
        "copiedFrom": "Atom (2,000+ schools); Exam Happy free for schools",
        "effort": "High",
        "cost": "£0 cash",
        "target": "2 schools signed"
      },
      {
        "id": "p3-tuition-upsell",
        "week": 16,
        "action": "Tuition upsell from mock reports, using the existing tuition request form",
        "copiedFrom": "Eleven Ace coaching from £30 a session; PiAcademy £399 for 5 sessions",
        "effort": "Medium",
        "cost": "£0",
        "target": "Tuition requests per month tracked"
      },
      {
        "id": "p3-paid-ads",
        "week": 21,
        "action": "Paid ads: retarget site visitors and geo-target grammar areas, only once free-to-paid works",
        "copiedFrom": "Atom scaled ads after cutting cost per acquisition 22%",
        "effort": "Medium",
        "cost": "Budget is the owner's call (not grounded)",
        "target": "Cost per paid customer below first-month revenue"
      },
      {
        "id": "p3-month6-targets",
        "week": 26,
        "action": "Store and audience targets for month 6",
        "copiedFrom": "Exam Happy 216 ratings; Atom 1,000+ Android installs",
        "effort": "Ongoing",
        "cost": "£0",
        "target": "100 ratings; 1,000+ Play installs"
      }
    ]
  }
];

// Each roadmap item: "id" is the stable key the backend stores progress and comments under
// (never change it once used); "week" is the planned start week (Month 1 = weeks 1-4 ... Month 6 = weeks 21-26).
export const ROADMAP_NOTE = "Targets are goals tied to the leaders’ numbers, not forecasts. Costs are given only where they’re known; otherwise the budget is the owner’s call.";

export const KPIS = [
  {
    "kpi": "Visitors",
    "definition": "Sessions on site and store pages",
    "breakdown": "UTM source, medium, campaign; landing page",
    "why": "Shows which channels bring people"
  },
  {
    "kpi": "Free game plays",
    "definition": "Rounds started and finished without an account",
    "breakdown": "Game, channel",
    "why": "The front door; Pip's model"
  },
  {
    "kpi": "Leads",
    "definition": "Emails captured (mini-mock, email course, webinar, newsletter)",
    "breakdown": "Lead magnet, channel",
    "why": "Atom's funnel starts here"
  },
  {
    "kpi": "Sign-ups",
    "definition": "Parent accounts created",
    "breakdown": "Channel; web, iOS or Android",
    "why": "Atom lost 76% of visitors at this step before its redesign"
  },
  {
    "kpi": "Trials started and activated",
    "definition": "Trials; activated = child did 1 mock or 3 sessions in the first 3 days (suggested)",
    "breakdown": "Channel",
    "why": "Predicts paying"
  },
  {
    "kpi": "Trial to paid",
    "definition": "Share of trials that pay",
    "breakdown": "Plan and channel",
    "why": "Atom's pricing change lifted it 5%"
  },
  {
    "kpi": "Paid customers and revenue",
    "definition": "New paid, monthly recurring revenue, plan mix, one-off pack sales",
    "breakdown": "Plan, product, channel",
    "why": "The outcome"
  },
  {
    "kpi": "Cancellations",
    "definition": "Monthly cancellations and reasons",
    "breakdown": "Plan",
    "why": "Keeps growth honest"
  },
  {
    "kpi": "Referrals",
    "definition": "Invites, referred sign-ups, referred paid, tutor affiliate sales",
    "breakdown": "Referrer type",
    "why": "Atom's £30/£30 and 15% schemes"
  },
  {
    "kpi": "Store health",
    "definition": "Ratings count and average; installs",
    "breakdown": "Store",
    "why": "Exam Happy: 216 ratings"
  },
  {
    "kpi": "Events",
    "definition": "Webinar sign-ups and attendance; mock-day entrants",
    "breakdown": "Event",
    "why": "Atom: 6 webinars in a month"
  },
  {
    "kpi": "Cost per lead, trial and paid",
    "definition": "Ad spend divided by each",
    "breakdown": "Campaign",
    "why": "Only once ads run"
  }
];

export const KPI_NOTE = "Show these as a funnel (visitors, game plays, leads, sign-ups, trials, paid) for each UTM source, by week.";

export const SOURCES = [
  {
    "title": "11 Plus Magic pricing",
    "site": "11plusmagic.co.uk",
    "href": "https://11plusmagic.co.uk/pricing"
  },
  {
    "title": "11 Plus Magic on the App Store (in-app purchases)",
    "site": "apps.apple.com",
    "href": "https://apps.apple.com/gb/app/11-plus-magic/id6768925108"
  },
  {
    "title": "11 Plus Magic YouTube",
    "site": "youtube.com",
    "href": "https://www.youtube.com/@11plusmagic"
  },
  {
    "title": "11 Plus Magic NVR puzzle Short (154 views)",
    "site": "youtube.com",
    "href": "https://www.youtube.com/watch?v=Le7pqP6NY80"
  },
  {
    "title": "11 Plus Magic TikTok",
    "site": "tiktok.com",
    "href": "https://www.tiktok.com/@11plusmagic"
  },
  {
    "title": "Atom Learning Facebook",
    "site": "facebook.com",
    "href": "https://www.facebook.com/weareatomlearning/"
  },
  {
    "title": "Atom Learning Instagram",
    "site": "instagram.com",
    "href": "https://www.instagram.com/atomlearning/"
  },
  {
    "title": "Atom free CEM practice questions post",
    "site": "instagram.com",
    "href": "https://www.instagram.com/atomlearning/p/C6HFn0qx3N8/"
  },
  {
    "title": "Atom Learning TikTok",
    "site": "tiktok.com",
    "href": "https://www.tiktok.com/@atomlearning"
  },
  {
    "title": "Atom Learning YouTube",
    "site": "youtube.com",
    "href": "https://www.youtube.com/@atomlearning"
  },
  {
    "title": "Atom: NVR Nets and Cubes (28K views)",
    "site": "youtube.com",
    "href": "https://www.youtube.com/watch?v=faLjNlsQDJ0"
  },
  {
    "title": "Atom free parent webinars",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/webinars"
  },
  {
    "title": "Atom free 11+ email course for parents",
    "site": "atomlearning.co.uk",
    "href": "https://resources.atomlearning.co.uk/free-11-course-for-parents"
  },
  {
    "title": "Atom free practice papers and mock",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/features/11-plus-practice-papers"
  },
  {
    "title": "Atom sitemap",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/sitemap.xml"
  },
  {
    "title": "Atom refer a friend",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/referrals"
  },
  {
    "title": "Atom tutor terms (15% referral)",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/tutor-terms"
  },
  {
    "title": "Atom discounts",
    "site": "atomlearning.com",
    "href": "https://www.atomlearning.com/discounts"
  },
  {
    "title": "Atom mum-blogger code (Emma and 3)",
    "site": "emmaand3.com",
    "href": "https://www.emmaand3.com/atom-learning-discount-code/"
  },
  {
    "title": "Atom acquisition case study",
    "site": "joshuasantoso.com",
    "href": "https://joshuasantoso.com/work/al-website"
  },
  {
    "title": "Atom tech stack listing",
    "site": "runsonwhat.com",
    "href": "https://www.runsonwhat.com/company/atomlearning.com"
  },
  {
    "title": "Maidstone Grammar School and Atom (X)",
    "site": "x.com",
    "href": "https://x.com/AtomLearning/status/1887466502837727428"
  },
  {
    "title": "Atom Learning on LinkedIn",
    "site": "linkedin.com",
    "href": "https://linkedin.com/company/atom-learning"
  },
  {
    "title": "CGP Books brand profile",
    "site": "open.endole.co.uk",
    "href": "https://open.endole.co.uk/insight/brand/68583-cgp-books"
  },
  {
    "title": "CGP TikTok",
    "site": "tiktok.com",
    "href": "https://www.tiktok.com/@cgpbooks"
  },
  {
    "title": "Exam Papers Plus brand profile",
    "site": "open.endole.co.uk",
    "href": "https://open.endole.co.uk/insight/brand/83895-exam-papers-plus"
  },
  {
    "title": "Exam Papers Plus YouTube",
    "site": "youtube.com",
    "href": "https://www.youtube.com/c/ExamPapersPlus"
  },
  {
    "title": "EPP: School Search video (5.2M views)",
    "site": "youtube.com",
    "href": "https://www.youtube.com/watch?v=xDxy8eD2UZs"
  },
  {
    "title": "EPP 35% summer sale post",
    "site": "facebook.com",
    "href": "https://www.facebook.com/exampapersplus/posts/were-thrilled-to-announce-our-biggest-summer-sale-yet-enjoy-a-whopping-35-off-yo/959037919352284/"
  },
  {
    "title": "EPP in-person mock listing",
    "site": "exampapersplus.co.uk",
    "href": "https://exampapersplus.co.uk/browse/mock/eleven-plus/11-plus-mock-exam-c-independent-schools/"
  },
  {
    "title": "Exam Happy homepage and pricing",
    "site": "examhappy.co.uk",
    "href": "https://examhappy.co.uk/"
  },
  {
    "title": "Exam Happy App Store listing",
    "site": "apps.apple.com",
    "href": "https://apps.apple.com/gb/app/exam-happy-11-practice/id1552633179"
  },
  {
    "title": "Eleven Ace pricing",
    "site": "11plus.elevenace.com",
    "href": "https://11plus.elevenace.com/pricing/uk/"
  },
  {
    "title": "Eleven Ace 11+ programmes",
    "site": "elevenace.com",
    "href": "https://elevenace.com/11-plus/"
  },
  {
    "title": "Eleven Ace YouTube",
    "site": "youtube.com",
    "href": "https://www.youtube.com/@elevenace3254"
  },
  {
    "title": "Eleven Ace £24 mock coupon video",
    "site": "facebook.com",
    "href": "https://www.facebook.com/Elevenace11Plus/videos/-ace-the-11-exam-with-eleven-ace-1-year-mock-exam-access-for-just-24-use-coupon-/1166551885194748/"
  },
  {
    "title": "Eleven Plus Exams forum",
    "site": "elevenplusexams.co.uk",
    "href": "https://www.elevenplusexams.co.uk/forum/11plus/index.php"
  },
  {
    "title": "Forum thread: Atom mocks Latymer and HBS",
    "site": "elevenplusexams.co.uk",
    "href": "https://www.elevenplusexams.co.uk/forum/11plus/viewtopic.php?t=66003"
  },
  {
    "title": "Eleven Plus Exams mocks",
    "site": "mocks.elevenplusexams.co.uk",
    "href": "https://mocks.elevenplusexams.co.uk/"
  },
  {
    "title": "PiAcademy Instagram",
    "site": "instagram.com",
    "href": "https://www.instagram.com/piacademy_gcse_11plus/"
  },
  {
    "title": "PiAcademy Facebook",
    "site": "facebook.com",
    "href": "https://www.facebook.com/piacademytutors"
  },
  {
    "title": "PiAcademy: How we aced the 11+ (53K views)",
    "site": "youtube.com",
    "href": "https://www.youtube.com/watch?v=D2-gLF2Rp_8"
  },
  {
    "title": "Pip: 11+ mock providers compared",
    "site": "pip11plus.com",
    "href": "https://pip11plus.com/best-11-plus-mock-exam-providers"
  },
  {
    "title": "Brilliant Tutors Academy WhatsApp community posts",
    "site": "findglocal.com",
    "href": "https://www.findglocal.com/GB/Reading/985180581631186/Brilliant-Tutors-Academy"
  },
  {
    "title": "A-One Tuition WhatsApp groups",
    "site": "aonetuition.co.uk",
    "href": "https://aonetuition.co.uk/groups/"
  },
  {
    "title": "The 11 Plus Journey",
    "site": "skool.com",
    "href": "https://www.skool.com/the-11-plus-journey-6704/about"
  },
  {
    "title": "11+ Resource Group newsletter",
    "site": "flipbuilder.com",
    "href": "https://online.flipbuilder.com/mwcp/ccfe/files/basic-html/page4.html"
  },
  {
    "title": "Parent Facebook groups list",
    "site": "educationbrothers.co.uk",
    "href": "https://www.educationbrothers.co.uk/groups"
  },
  {
    "title": "11 Plus Guide",
    "site": "11plusguide.com",
    "href": "https://www.11plusguide.com/"
  },
  {
    "title": "Meta Ad Library",
    "site": "facebook.com",
    "href": "https://www.facebook.com/ads/library/"
  },
  {
    "title": "11 Plus Magic free games",
    "site": "11plusmagic.co.uk",
    "href": "https://11plusmagic.co.uk/games"
  },
  {
    "title": "11 Plus Magic mock exams",
    "site": "11plusmagic.co.uk",
    "href": "https://11plusmagic.co.uk/mock-exams"
  },
  {
    "title": "11 Plus Magic practice papers",
    "site": "11plusmagic.co.uk",
    "href": "https://11plusmagic.co.uk/practice-papers"
  },
  {
    "title": "11 Plus Magic on Google Play",
    "site": "play.google.com",
    "href": "https://play.google.com/store/apps/details?id=com.elevenplusmagic.app"
  },
  {
    "title": "Exam Happy pricing",
    "site": "examhappy.co.uk",
    "href": "https://examhappy.co.uk/pricing"
  },
  {
    "title": "What is Atom Home?",
    "site": "atomlearning.co.uk",
    "href": "https://resources.atomlearning.co.uk/en/knowledge/what-is-atom-home"
  },
  {
    "title": "Atom coins and rewards",
    "site": "atomlearning.co.uk",
    "href": "https://resources.atomlearning.co.uk/en/knowledge/what-are-coins-and-how-can-i-use-them-1"
  },
  {
    "title": "Pip homepage",
    "site": "pip11plus.com",
    "href": "https://pip11plus.com/"
  },
  {
    "title": "Pip on Google Play",
    "site": "play.google.com",
    "href": "https://play.google.com/store/apps/details?id=com.pip11plus.app"
  },
  {
    "title": "Eleven Ace Learn (game-style app)",
    "site": "elevenace.com",
    "href": "https://elevenace.com/11-plus-learning-platform"
  }
];

// Figures behind the tables above, as read on 30 Oct 2026, in the shape the backend seeds
// (CompetitorMetricsSeeder). The Competitors tab shows these when the live figures API is unreachable.
export const COMPETITOR_METRICS_SEED = [
  {
    key: "ours", name: "11 Plus Magic", isOurs: true,
    appStoreId: "6768925108", youtubeChannelId: "UCCcsL4Cnqum9PKvxhMZqXDQ", youtubeHandle: "@11plusmagic",
    metrics: {
      app_store_rating: 5, app_store_reviews: 1, youtube_subscribers: 17, youtube_videos: 278, youtube_views: 3049,
      facebook_followers: 71, instagram_followers: "Not found (login wall)", tiktok_followers: 7, tiktok_likes: 78,
      x_followers: "No account", play_installs: "10+",
    },
  },
  {
    key: "atom", name: "Atom Learning", isOurs: false,
    appStoreId: "6795516508", youtubeChannelId: "UCaHAWY6bhOFrvr7K5LRCzcA", youtubeHandle: "@AtomLearning",
    metrics: {
      youtube_subscribers: 4360, youtube_videos: 291, youtube_views: 1350000, facebook_followers: 8200,
      instagram_followers: 2960, tiktok_followers: 4265, tiktok_likes: 129600, x_followers: 895, linkedin_followers: 14200,
    },
  },
  {
    key: "exam_happy", name: "Exam Happy", isOurs: false,
    appStoreId: "1552633179", youtubeChannelId: null, youtubeHandle: null,
    metrics: {
      app_store_rating: 4.48, app_store_reviews: 216, play_installs: "10K+", facebook_followers: "Page active; count not found",
      tiktok_followers: 7, tiktok_likes: 10, x_followers: "No account", linkedin_followers: 26,
    },
  },
  {
    key: "pip", name: "Pip", isOurs: false,
    appStoreId: "6775690698", youtubeChannelId: null, youtubeHandle: null,
    metrics: { app_store_rating: 4.15, app_store_reviews: 13, play_installs: "500+" },
  },
  {
    key: "eleven_ace", name: "Eleven Ace", isOurs: false,
    appStoreId: null, youtubeChannelId: "UCdeHtPE7V40R9H8oUxqGSxA", youtubeHandle: "@elevenace3254",
    metrics: {
      youtube_subscribers: 53, youtube_videos: 35, facebook_followers: "Page active; count not found",
      instagram_followers: "Account exists; count not found", x_followers: "No account",
    },
  },
  {
    key: "cgp", name: "CGP", isOurs: false,
    appStoreId: null, youtubeChannelId: "UCDXzr5LPQCkA6JNo1tw6NDg", youtubeHandle: "@CGPBooksVideos",
    metrics: {
      youtube_subscribers: 7510, youtube_videos: 90, facebook_followers: 9700, instagram_followers: 21000,
      tiktok_followers: 38400, tiktok_likes: 1600000, x_followers: 1468, linkedin_followers: 2229,
    },
  },
  {
    key: "exam_papers_plus", name: "Exam Papers Plus", isOurs: false,
    appStoreId: null, youtubeChannelId: "UCb7E1JCno_UttM3wtS4wiEQ", youtubeHandle: "@ExamPapersPlus",
    metrics: {
      youtube_subscribers: 2490, youtube_videos: 585, youtube_views: 10100000, facebook_followers: 2900,
      instagram_followers: "Not found", tiktok_followers: 10, tiktok_likes: 77, x_followers: 744, linkedin_followers: 1107,
      trustpilot_reviews: 1562,
    },
  },
  {
    key: "eleven_plus_exams", name: "Eleven Plus Exams", isOurs: false,
    appStoreId: null, youtubeChannelId: null, youtubeHandle: null,
    metrics: {
      facebook_followers: "Page active; count not found", instagram_followers: "Account exists; count not found",
      tiktok_followers: 511, tiktok_likes: 1050, x_followers: 564, forum_members: 41391, forum_posts: 797420,
      trustpilot_rating: 4.8, trustpilot_reviews: 267,
    },
  },
  {
    key: "piacademy", name: "PiAcademy", isOurs: false,
    appStoreId: null, youtubeChannelId: "UC3RgaLScVBfDX3NPTw-ZAqw", youtubeHandle: "@piacademy_gcse_11plus",
    metrics: {
      youtube_subscribers: 1680, youtube_videos: 36, facebook_followers: 1000, instagram_followers: 1746,
      x_followers: 62, linkedin_followers: 5045,
    },
  },
  {
    key: "schofield_sims", name: "Schofield & Sims", isOurs: false,
    appStoreId: null, youtubeChannelId: "UCOE8lKiz6k6XQFyCpZ81Xrg", youtubeHandle: "@SchofieldandSims",
    metrics: { youtube_subscribers: 157, youtube_videos: 126, facebook_followers: "Page exists; count not found", x_followers: 1172 },
  },
  {
    key: "eleven_plus_guide", name: "11 Plus Guide", isOurs: false,
    appStoreId: null, youtubeChannelId: null, youtubeHandle: null,
    metrics: { facebook_followers: "Page exists; count not found", x_followers: 21 },
  },
];
